<template>
  <van-overlay :show="show" @click="closeGuide">
    <div class="guide_item" :style="{ top: top }">
      <div class="selTxt">{{ selCountryInfo.content }}</div>
      <div class="guide_desc">{{ $t('m.EnterIDTip', { msg: getAppName() }) }}</div>
    </div>
  </van-overlay>
</template>
<script>
import Vue from 'vue';
import { Overlay, } from 'vant';
import {getAppName} from "../util";
Vue.use(Overlay);
export default{
  name:'guide',
  components: {

  },
  props: {
      top:{
        type:String,
        default:'2.8rem',
      },
      selCountryInfo:{},
      show: {
        type: Boolean,
        default: false
      }
  },
  data(){
    return{

    }
  },
  mounted() {

  },
  methods:{
    getAppName,
    //关闭引导
    closeGuide() {
      localStorage.setItem('isFristEnter', 1);
      this.$emit('close');
    },
  }
}
</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/guide.vue